import React from "react";
import { useTranslation } from "react-i18next";

import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import Input from "shared/components/FormElements/Input";
import { isValidPhoneForMobileLogin } from "shared/util/mobile-login-phone";

// Read-only display of a user's personal login code (User.loginCode).
// Shown only when the user has a valid phone on file — mobile auth is keyed by phonenumber.
const noop = () => {};

const LoginCodeField = ({ loginCode, phoneNumber, countryCode }) => {
  const { t } = useTranslation();

  const phoneOk = isValidPhoneForMobileLogin(phoneNumber, countryCode);
  const displayValue = phoneOk && loginCode ? loginCode : "-";
  const canCopy = phoneOk && !!loginCode;

  const copyToClipboard = async () => {
    if (!canCopy) return;
    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(loginCode);
      } else {
        const el = document.createElement("textarea");
        el.value = loginCode;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
      }
      window?.toast?.success?.(t("copied"));
    } catch (err) {
      window?.toast?.error?.(t("actionFailed"));
    }
  };

  return (
    <div
      style={{
        flex: 1,
        minWidth: 0,
        display: "flex",
        alignItems: "flex-end",
        columnGap: 4,
        marginBottom: "1rem",
      }}
    >
      <Input
        key={`loginCode-${displayValue}`}
        id="loginCode"
        element="input"
        type="text"
        label={t("loginCode")}
        description={t("loginCodeDescription")}
        initialValue={displayValue}
        initialValid={true}
        onInput={noop}
        disabled={true}
        style={{ flex: 1, minWidth: 0, marginBottom: 0 }}
        elementStyle={{ letterSpacing: displayValue === "-" ? undefined : "2px", fontWeight: 600 }}
      />
      <Tooltip title={canCopy ? t("copy") : ""}>
        <span>
          <IconButton
            onClick={copyToClipboard}
            aria-label={t("copy")}
            disabled={!canCopy}
            style={{ marginBottom: "1rem" }}
          >
            <ContentCopyIcon />
          </IconButton>
        </span>
      </Tooltip>
    </div>
  );
};

export default LoginCodeField;
